import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { submitAdventureReply } from '../shared/submitAdventureReply'

const initialState = {
  value: 0,
}

export const replyToAdventure = createAsyncThunk(
  'replyAdventure/replyToAdventure',
  async ({ content, characterId, character, slug }, { rejectWithValue }) => {
    const resolvedCharacter = character || (characterId ? { characterId } : null)
    const result = await submitAdventureReply({
      content,
      character: resolvedCharacter,
      slug,
    })

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.message)
  }
)

const replyAdventureSlice = createSlice({
  name: 'replyAdventure',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(replyToAdventure.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(replyToAdventure.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.value = action.payload
      })
      .addCase(replyToAdventure.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.payload || action.error?.message
      })
  },
})

export default replyAdventureSlice.reducer
